import type { ImageLoaderProps } from 'next/image';

export const loaderImage = ({ src, width }: ImageLoaderProps) => {
  const apiEntryPoint = process.env['NEXT_PUBLIC_BUCKET_URL'];
  const path = '/assets';

  return `${apiEntryPoint || ''}${path}${src}?imwidth=${width}`;
};
